import { render } from "./SetPagePasswordModal.vue?vue&type=template&id=73f9c38c&scoped=true"
import script from "./SetPagePasswordModal.vue?vue&type=script&lang=js"
export * from "./SetPagePasswordModal.vue?vue&type=script&lang=js"

import "./SetPagePasswordModal.vue?vue&type=style&index=0&id=73f9c38c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f9c38c"]])

export default __exports__